<ng-container  *ngIf="!resetComplete; else confirmation">
<div class="modal-content">
  <div>
    <div class="modal-header">
      <h1 class="modal-title">
        Reset Password
      </h1>
    </div>
    <form [formGroup]="dealerForm" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div class="row mb-2">
          <div class="col-md-12">
            <div>All fields are required.</div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-8 offset-sm-2">
            <div class="form-group">
              <label for="licenseId">Dealer ID</label>
              <input min="1" formControlName="licenseId" id="licenseId" name="licenseId" class="form-control required" aria-required="true" aria-label="license Id"
                [attr.aria-invalid]="dealerForm.get('licenseId').hasError('required') && dealerForm.touched" [ngClass]="{'is-invalid': dealerForm.get('licenseId').hasError('required') && dealerForm.touched}" >
                <div *ngIf="dealerForm.get('licenseId').hasError('validDealerId')  && dealerForm.touched" role="alert" class="formError text-danger" aria-live="assertive">
                  Please, enter a valid Id of the Dealer.
                </div>
                <div *ngIf="dealerForm.get('licenseId').hasError('required') && dealerForm.touched" role="alert" class="formError text-danger" aria-live="assertive">
                  Please, enter the ID of the Dealer.
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button *ngIf="!loading" type="submit" [disabled]="dealerForm.invalid || dealerForm.pristine" class="btn btn-primary btn mr-1">
          <i class="fas fa-check"> </i>&nbsp;Reset
        </button>
        <i *ngIf="loading" class="fa fa-spinner fa-spin"></i>
        <button class="btn btn-secondary btn" type="button" (click)="onCancelClick()">
          <i class="fas fa-times"> </i>&nbsp;Cancel
        </button>
      </div>
    </form>
  </div>
</div>
</ng-container>
<ng-template #confirmation>
  <div [ngClass]="{'alert-danger': !resetSuccess, 'alert-success': resetSuccess}" class="alert bottom">
    <button type="button" class="close" aria-label="Close" (click)="onCancelClick()">
      <span aria-hidden="true">&times;</span>
    </button>

    <h4>
      {{resetCofirmationTitle}}
    </h4>
    <p>{{resetCofirmationMessage}}</p>
  </div>
</ng-template>
